/**
 * Contact side panel: open and close only.
 *
 * The dialog element supplies the dark surround, the focus trap, Escape, the
 * return of focus to the trigger and the inertness of the page behind it, so
 * none of that is reimplemented here.
 *
 * Every trigger is a real link to /pages/contact in the markup. This upgrades
 * the click to the panel and leaves the link working when the script is absent
 * or still loading, so the route is never dependent on JavaScript.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-tn-contact-open]';

  function panel() {
    return document.getElementById('TnContactPanel');
  }

  function open(event) {
    var dlg = panel();
    if (!dlg || typeof dlg.showModal !== 'function') return; // let the link navigate
    event.preventDefault();
    if (!dlg.open) dlg.showModal();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(SELECTOR);
    if (trigger) {
      open(event);
      return;
    }

    var closer = event.target.closest('[data-tn-contact-close]');
    if (closer) {
      var dlg = panel();
      if (dlg && dlg.open) dlg.close();
      return;
    }

    /* Clicking the backdrop: the dialog fills the viewport, so a click that
       lands on the dialog itself rather than on the panel inside it is a click
       outside the panel. */
    var dlg2 = panel();
    if (dlg2 && dlg2.open && event.target === dlg2) dlg2.close();
  });
})();
